import { Tab, Tabs } from "@mui/material";
import React from "react";
import useProduct from "./useProduct";
import { Ptag } from "components/core";
import { getProductIcon } from "utlis/utils";
import { ProductTabWrapper, TabsContainer } from "./styles";

function CoverageDetailsTabs({ activeProduct, setActiveProduct, products }) {
  const { productNames } = useProduct({ products });
  const showScrollButtons = productNames.length > 5;
  
  return (
    <TabsContainer>
      <Tabs
        value={activeProduct}
        onChange={(_, newValue) => setActiveProduct(newValue)}
        variant="scrollable"
        scrollButtons={showScrollButtons ? "auto" : false}
        allowScrollButtonsMobile={showScrollButtons}
        TabIndicatorProps={{
          style: {
            display: "none",
          },
        }}
        sx={{
          marginBottom: "-2px !important",
          width: "100%",
          "& .MuiTabs-flexContainer": {
            gap: "10px",
          },
          "& .MuiTabs-scrollButtons": {
            color: "#231A3D",
            backgroundColor: "rgba(35, 26, 61, 0.05)",
            borderRadius: "4px",
            margin: "0 4px",
            "&:hover": {
              backgroundColor: "rgba(35, 26, 61, 0.1)",
            },
            "&.Mui-disabled": {
              opacity: 0.3,
            },
          },
        }}
      >
        {productNames.map(({ display_name, value }, index) => (
          <Tab
            sx={{
              fontSize: "14px !important",
              textTransform: "none",
              marginBottom: "-2px !important",
              color: "#231A3D !important",
              fontWeight: "500 !important",
              borderRadius: "10px 10px 0px 0px",
              border: "1px solid #452D84",
              marginRight: "0px !important",
              minWidth: "fit-content",
              padding: "12px 20px",
              transition: "all 0.3s ease !important",
              border: "1px solid #D8D0F1 !important",
              "&.Mui-selected": {
                transition: "all 0.3s ease !important",
                backgroundColor: "#F3EEFF !important",
                border: "1px solid #D8D0F1 !important",
                borderWidth: "1px 1px 0px 1px !important",
                marginRight: "0px !important",
              },
            }}
            label={
              <ProductTabWrapper>
                <img src={getProductIcon(value)} alt="" />
                <Ptag letterSpacing="0.25px" fontSize="14px">{display_name}</Ptag>
              </ProductTabWrapper>
            }
            key={index}
            value={value}
          />
        ))}
      </Tabs>
    </TabsContainer>
  );
}

export default CoverageDetailsTabs;
